var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.00195V8.42195C22 10.002 21 11.002 19.42 11.002H16V4.01195C16 2.90195 16.91 2.00195 18.02 2.00195C19.11 2.01195 20.11 2.45195 20.83 3.17195C21.55 3.90195 22 4.90195 22 6.00195Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.00195V21.002C2 21.832 2.94001 22.302 3.60001 21.802L5.31 20.522C5.71 20.222 6.27 20.262 6.63 20.622L8.28999 22.292C8.67999 22.682 9.32001 22.682 9.71001 22.292L11.39 20.612C11.74 20.262 12.3 20.222 12.69 20.522L14.4 21.802C15.06 22.292 16 21.822 16 21.002V4.00195C16 2.90195 16.9 2.00195 18 2.00195H7H6C3 2.00195 2 3.79195 2 6.00195V7.00195Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.75195H6C5.59 9.75195 5.25 9.41195 5.25 9.00195C5.25 8.59195 5.59 8.25195 6 8.25195H12C12.41 8.25195 12.75 8.59195 12.75 9.00195C12.75 9.41195 12.41 9.75195 12 9.75195Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.752H6.75C6.34 13.752 6 13.412 6 13.002C6 12.592 6.34 12.252 6.75 12.252H11.25C11.66 12.252 12 12.592 12 13.002C12 13.412 11.66 13.752 11.25 13.752Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.12c1351496e05b5bffaccb4840d04014.svg";
export { ForwardRef as ReactComponent };